export default "__VITE_ASSET__DNPUIPW___"